<template>
    <div class="amenity-card" :class="{ 'is_highlight': item && item.is_highlight, 'small': small, 'inline': inline }">
        <!-- Icon -->
        <i class="icon wa-icon-check-circle" v-if="! item.icon && ! icon && ! iconText"></i>
        <i class="icon" v-if="iconText">{{ iconText }}</i>
        <i class="icon" :class="[item.icon || icon]" v-if="item.icon || icon"></i>

        <span class="name" v-if="item.name && item.name">
            <span v-if="! item.short_name">
                {{ item.name }}
            </span>

            <span v-if="item.short_name">
                {{ item.short_name }}
            </span>
        </span>

        <span class="name" v-if="! item">
            {{ ! shortName ? name : shortName }}
        </span>
    </div>
</template>

<script>
    export default {
        props: ['item', 'icon', 'name', 'shortName', 'small', 'inline', 'iconText'],
        data() {
            return {}
        },
        mounted() {},
        computed: {},
        methods: {},
        watch: {}
    }
</script>
